/**
 * Custom Header JavaScript
 * Handles Mega Menu, Swiper, and Mobile Menu interactions.
 */

(function () {
    "use strict";

    const Header = {
        init() {
            this.initSwipers();
            this.initTabs();
            this.initMobileMenu();
            this.initOverlay();
        },

        initSwipers() {
            const swiperContainers = document.querySelectorAll('.mega-product-swiper');
            swiperContainers.forEach((container) => {
                if (container.swiper) return; // Already initialized

                new Swiper(container, {
                    slidesPerView: 3,
                    spaceBetween: 20,
                    observer: true,
                    observeParents: true,
                    pagination: {
                        el: '.swiper-pagination',
                        clickable: true,
                    },
                });
            });
        },

        initTabs() {
            // Use event delegation for tab switching
            document.addEventListener('mouseover', (event) => {
                const trigger = event.target.closest('[data-tab-trigger]');
                if (!trigger) return;

                const container = trigger.closest('.mega-menu-wrapper');
                if (!container) return;

                const index = trigger.dataset.tabTrigger;

                // Update List Items
                const listItems = container.querySelectorAll('[data-tab-trigger]');
                listItems.forEach(item => item.classList.remove('active'));
                trigger.classList.add('active');

                // Update Tab Content
                const tabs = container.querySelectorAll('[data-tab-content]');
                tabs.forEach(tab => {
                    tab.classList.remove('active');
                    if (tab.dataset.tabContent === index) {
                        tab.classList.add('active');
                    }
                });
            });
        },

        initMobileMenu() {
            const menuButton = document.querySelector('.menu-button');
            const mobileMenu = document.querySelector('.mobile-menu');
            const body = document.body;

            if (menuButton && mobileMenu) {
                // Clone button to remove old event listeners if any (optional, but safer if re-initializing)
                // For now, we assume simple addition.

                menuButton.addEventListener('click', function () {
                    mobileMenu.classList.toggle('active');
                    const isOpen = mobileMenu.classList.contains('active');

                    if (isOpen) {
                        body.style.overflow = 'hidden';
                        menuButton.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>';
                    } else {
                        body.style.overflow = '';
                        menuButton.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="3" y1="12" x2="21" y2="12"></line><line x1="3" y1="6" x2="21" y2="6"></line><line x1="3" y1="18" x2="21" y2="18"></line></svg>';
                    }
                });
            }

            // Mobile Accordion Logic
            const mobileDropdowns = document.querySelectorAll('.mobile-dropdown .mobile-nav-menu');
            mobileDropdowns.forEach(trigger => {
                trigger.addEventListener('click', function (e) {
                    // Check if it has a sibling dropdown
                    const content = this.nextElementSibling;
                    if (content && content.classList.contains('mobile-dropdown-content')) {
                        e.preventDefault();
                        content.classList.toggle('show');
                        this.classList.toggle('expanded');
                    }
                });
            });
        },

        initOverlay() {
            const overlay = document.querySelector('.body-overlay');
            const dropdowns = document.querySelectorAll('.navbar .dropdown');

            if (!overlay) return;

            dropdowns.forEach(dropdown => {
                const dropdownContent = dropdown.querySelector('.dropdown-content');
                if (dropdownContent) {
                    dropdown.addEventListener('mouseenter', () => {
                        overlay.classList.add('is-active');
                    });
                    dropdown.addEventListener('mouseleave', () => {
                        overlay.classList.remove('is-active');
                    });
                }
            });
        }
    };

    // Initialize on DOMContentLoaded
    document.addEventListener('DOMContentLoaded', () => {
        Header.init();
    });

    // Re-initialize on Shopify section load (for editor support)
    document.addEventListener('shopify:section:load', () => {
        Header.init();
    });

})();
